module.exports = __webpack_public_path__ + "static/img/ots-en-US.50dfcfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ots-en-US.png
// module id = kIi7
// module chunks = 1